/* eslint-disable no-shadow */
/* eslint-disable operator-linebreak */
/* eslint-disable object-curly-newline */
/* eslint-disable camelcase */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// import * as Yup from 'yup';
import { toast } from 'react-toastify';

import { Container, Header, ButtonTest } from './styles';

import history from '~/services/history';
import api from '~/services/api';

export default function Cards() {
  const { id } = useParams();
  const [card, setCard] = useState('');
  const [position, setPosition] = useState('');
  const [source, setSource] = useState('');
  const [channel, setChannel] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [link, setLink] = useState('');
  const [youtube, setYoutube] = useState('');

  useEffect(() => {
    async function getDataCard() {
      const { data } = await api.get(`/cards/${id}`);

      setCard(data.module);
      setPosition(data.position);
      setSource(data.source);
      setChannel(data.channel);
      setTitle(data.title);
      setContent(data.content);
      setLink(data.link);
      setYoutube(data.youtube_code);
    }

    getDataCard();
  }, [id]);

  async function handleUpdate(e) {
    e.preventDefault();
    try {
      await api.put(`/cards/${id}`, {
        card,
        position,
        source,
        channel,
        title,
        content,
        link,
        youtube,
      });

      return toast.success('Card atualizado com sucesso.');
    } catch (error) {
      return toast.error('Erro ao atualizar o card, tente novamente');
    }
  }

  return (
    <>
      <Header>
        <ButtonTest type="submit" onClick={() => history.push('/level')}>
          <h2>Level</h2>
        </ButtonTest>
        <ButtonTest type="submit" onClick={() => history.push('/subject')}>
          <h2>Subject</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/module')}>
          <h2>Modules</h2>
        </ButtonTest>

        <ButtonTest
          selected
          type="submit"
          onClick={() => history.push('/card')}
        >
          <h2>Cards</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/challenge')}>
          <h2>Challenges</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/jobs')}>
          <h2>Jobs</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/file')}>
          <h2>Files</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/users')}>
          <h2>Users</h2>
        </ButtonTest>
      </Header>

      <Container>
        <h1>Atualize Cards:</h1>
        <form onSubmit={handleUpdate}>
          <div className="support">
            <div className="select">
              <p>Modulo do Card: {card.title} </p>
            </div>
            <div className="input">
              <p>Posiçāo no Módulo:</p>
              <input
                type="text"
                value={position}
                onChange={(event) => setPosition(event.target.value)}
              />
            </div>

            <div className="input">
              <p>Fonte do conteúdo:</p>
              <input
                type="text"
                value={source}
                onChange={(event) => setSource(event.target.value)}
              />
            </div>

            <div className="input">
              <p>Canal do conteúdo:</p>
              <input
                type="text"
                value={channel}
                onChange={(event) => setChannel(event.target.value)}
              />
            </div>

            <div className="input">
              <p>Título do conteúdo:</p>
              <input
                type="text"
                value={title}
                onChange={(event) => setTitle(event.target.value)}
              />
            </div>

            <div className="textArea">
              <p>Descriçāo do conteúdo:</p>
              <textarea
                type="text"
                value={content}
                onChange={(event) => setContent(event.target.value)}
              />
            </div>

            <div className="input">
              <p>Link do conteúdo:</p>
              <input
                type="text"
                value={link}
                onChange={(event) => setLink(event.target.value)}
              />
            </div>

            <div className="input">
              <p>Código do vídeo do conteúdo:</p>
              <input
                type="text"
                value={youtube}
                onChange={(event) => setYoutube(event.target.value)}
              />
            </div>
          </div>
          <button className="form" type="submit">
            ATUALIZAR
          </button>
        </form>
      </Container>
    </>
  );
}
